import Repository from '../Repository';

const resource = '/report';

export default {
	home() {
		return Repository.get(`${resource}/home`);
	}
}